import React from 'react';
import { useFormikContext } from 'formik';

import { NoPreferenceButtonStyled } from '../ShiftPreferencesModal.styled';
import { label } from '@/shared/ui/core';

const NoPreferenceButton = ({ options, field, defaultValue, afterOnClick }) => {
  const { setFieldValue } = useFormikContext();

  const handleClick = () => {
    if (!options?.length) {
      setFieldValue(field, defaultValue || true);
      return afterOnClick();
    }

    options.forEach((option) => {
      const name = `${field}__${option.value}`;
      setFieldValue(name, defaultValue || true);
    });

    return afterOnClick();
  };

  return (
    <NoPreferenceButtonStyled
      onClick={handleClick}
      {...label('I have no preference')}
    >
      I have no preference
    </NoPreferenceButtonStyled>
  );
};

export default NoPreferenceButton;
